"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const coverageCostCalc_1 = __importDefault(require("../coverageCostCalc"));
const coverageRateOptionRestrictions_1 = __importDefault(require("../coverageRateOptionRestrictions"));
class CoverageRate {
    constructor(costCalcs, optionRestrictions, productId, zIndex = 0) {
        var _a;
        this.costCalcs = costCalcs;
        this.optionRestrictions = optionRestrictions;
        this.productId = productId;
        this.zIndex = zIndex;
        if (this.zIndex === 0 && ((_a = optionRestrictions.accountId) === null || _a === void 0 ? void 0 : _a.length)) {
            this.zIndex = 0.5;
        }
        this.limitRange = this.costCalcs
            .map((costCalc) => costCalc.limitRange)
            .reduce((prev, curr) => (!prev ? curr : prev.union(curr)));
    }
    static fromObj(data) {
        const optionRestrictions = data.optionRestrictions
            ? coverageRateOptionRestrictions_1.default.fromObj(data.optionRestrictions)
            : {};
        return new CoverageRate(data.costCalcs.map(coverageCostCalc_1.default.fromObj), optionRestrictions, data.productId, data.zIndex);
    }
}
exports.default = CoverageRate;
//# sourceMappingURL=coverageRate.class.js.map